import { render, staticRenderFns } from "./Helfen.vue?vue&type=template&id=63129868&scoped=true&"
import script from "./Helfen.vue?vue&type=script&lang=js&"
export * from "./Helfen.vue?vue&type=script&lang=js&"
import style0 from "./Helfen.vue?vue&type=style&index=0&id=63129868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63129868",
  null
  
)

export default component.exports